export default "__VITE_ASSET__BVOTnAdN__"